import { render, staticRenderFns } from "./QuoteCarousel.vue?vue&type=template&id=00658f29&scoped=true"
import script from "./QuoteCarousel.vue?vue&type=script&lang=ts"
export * from "./QuoteCarousel.vue?vue&type=script&lang=ts"
import style0 from "./QuoteCarousel.vue?vue&type=style&index=0&id=00658f29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00658f29",
  null
  
)

export default component.exports